export const LANGUAGES_TYPE = {
  EN: "en",
  HE: "he",
} as const

export const LANGUAGES: {
  value: string
  language: string
}[] = [
  { value: LANGUAGES_TYPE.EN, language: "English" },
  { value: LANGUAGES_TYPE.HE, language: "Hebrew" },
]
